import styled from "@emotion/styled";

export const AppBodyLayoutWrapper = styled.div`
  box-sizing: border-box;
  padding: 32px 0 0;
  min-height: calc(100vh - 74px);
`;
